/* tslint:disable */
/* eslint-disable */
/**
 * e-SNRWB
 * Opis api e-SNRWB
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FilterYearData
 */
export interface FilterYearData {
    /**
     * 
     * @type {number}
     * @memberof FilterYearData
     */
    newYear?: number;
    /**
     * 
     * @type {string}
     * @memberof FilterYearData
     */
    organizationalUnitId?: string;
}

export function FilterYearDataFromJSON(json: any): FilterYearData {
    return FilterYearDataFromJSONTyped(json, false);
}

export function FilterYearDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilterYearData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'newYear': !exists(json, 'newYear') ? undefined : json['newYear'],
        'organizationalUnitId': !exists(json, 'organizationalUnitId') ? undefined : json['organizationalUnitId'],
    };
}

export function FilterYearDataToJSON(value?: FilterYearData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'newYear': value.newYear,
        'organizationalUnitId': value.organizationalUnitId,
    };
}


